export enum Role {
  Admin,
  Therapist,
  Owner,
}
